import React from 'react';

export function normalizeComponent(intl, id) {
    const messages = intl.formatMessage({id}).split(" ");
    return messages.length > 1
        ? <>{messages[0]} <span>{messages[1]}</span></>
        : <span>{messages[0]}</span>;
}
